import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Injector, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IInputComponent } from '@nimbus-library/features/shared/components/material/i-input-component';
import { InputDatePickerHeaderComponent } from '@nimbus-library/features/shared/components/material/input-date-picker/input-date-picker-header/input-date-picker-header.component';

@Component({
  standalone: false,
  selector: 'nimbus-input-date-picker',
  templateUrl: './input-date-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputDatePickerComponent),
    },
  ],
})
export class InputDatePickerComponent extends IInputComponent {
  public header = InputDatePickerHeaderComponent;

  @Input()
  public min: any;

  @Input()
  public max: any;

  @Input()
  public removable: boolean = true;

  public constructor(
    private changeDetectionRef: ChangeDetectorRef,
    private injector: Injector,
    private readonly translateService: TranslateService,
  ) {
    super(changeDetectionRef, injector, translateService);
  }
}
